import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        userInfo:null,
        userToken:null,
        shareData:null,
    },
    mutations:{
        setUserInfo(state,data){
            state.userInfo = data
        },
        setShareData(state,data){
            state.shareData = data
        },
        setUserToken(state,data){
            state.userToken = data
        },
    }
})


// WEBPACK FOOTER //
// ./src/store.js